<div class="epic-confirmation">
	<div class="epic-confirmation__message">
		<epic-form-field>
			<epic-select
				[ngStyle]="{ '--status-colour': statusTypeForm.formGroup.controls['statusType'].value?.colour }"
				[isClearVisible]="false"
				[control]="statusTypeForm.formGroup.controls['statusType']"
				[customSelectedValues]="true">
				<div
					class="epic-select__custom-values"
					selected-values>
					<div class="epic-select__selected">
						<div
							class="epic-select__colour"
							[style.background-color]="statusTypeForm.formGroup.controls['statusType'].value?.colour"></div>
						{{ getItemTranslation(statusTypeForm.formGroup.controls['statusType'].value) }}
					</div>
				</div>
				@for (status of statuses; track status) {
					<epic-option
						[value]="status"
						[ngStyle]="{ '--icon-colour': status.colour }"
						[selected]="order.conveyance_type?.id === status.id"
						class="epic_select__option">
						<div class="epic-select__selected">
							<div
								class="epic-select__colour"
								[style.background-color]="status.colour"></div>
							{{ getItemTranslation(status) }}
						</div>
					</epic-option>
				}
			</epic-select>
		</epic-form-field>
	</div>
	<div class="epic-confirmation__actions">
		<epic-button
			[text]="confirmButtonText"
			(onClick)="updateStatus()" />
		<epic-button
			[text]="cancelButtonText"
			[isActive]="false"
			(onClick)="cancelUpdateConveyanceType()" />
	</div>
</div>
